import { render, staticRenderFns } from "./partition.vue?vue&type=template&id=240304e0&scoped=true"
import script from "./partition.vue?vue&type=script&lang=js"
export * from "./partition.vue?vue&type=script&lang=js"
import style0 from "./partition.vue?vue&type=style&index=0&id=240304e0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240304e0",
  null
  
)

export default component.exports